import {SimplePresentation, SimplePresentationRunnerController} from "../../core/presentation/SimplePresentationRunner";
import {gsap} from "gsap";
import {HOTB} from "../HOTB";
import {HOTBGameData} from "../server/HOTBData";
import {ExtendedGameMode} from "../server/ExtendedGameMode";
import {GameSymbol, SymbolsList, SymbolStates} from "../reels/GameSymbol";
import {ISymbol} from "../../core/reel/IReelData";

export class ScatterWinPresentation implements SimplePresentation {
    private _mainTl: gsap.core.Timeline;

    public shouldRun(): boolean {
        const gameData: HOTBGameData = HOTB.model.gameData;

        let flag: boolean = false;

        if (gameData.mode.includes(ExtendedGameMode.NORMAL) && gameData.nextMode.includes(ExtendedGameMode.FREESPIN)) {
            flag = true;
        }

        return flag;
    }

    public start(controller: SimplePresentationRunnerController): void {
        this._mainTl = gsap.timeline({
            delay: 0.2,
            onComplete: (): void => {
                this._mainTl.kill();
                controller.finish();
            }
        });

        this._mainTl.add((): void => {
            controller.setSkipCallback((): void => {
                this.onSkip();
            });
        }, 0.001);

        this._mainTl.add(this.runScatterWin());
    }

    private runScatterWin(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline(),
            evaluatedReels: string[][] = HOTB.model.gameData.evaluatedArea;

        for (let reelId: number = 0; reelId < evaluatedReels.length; reelId++) {
            const currReel: string[] = evaluatedReels[reelId];

            for (let symId: number = 0; symId < currReel.length; symId++) {
                const currSymName: string = currReel[symId];

                if (this.isScatter(currSymName)) {
                    const scatterSymbol: ISymbol = HOTB.reelArea.mainReelModels[reelId].getSymbol(symId);

                    tl.add((<GameSymbol>scatterSymbol).getStateAnimation(SymbolStates.WIN), 0);
                }
            }
        }

        return tl;
    }

    private isScatter(symName: string): boolean {
        let flag: boolean = false;

        if (symName === SymbolsList.S1 ||
            symName === SymbolsList.S2) {
            flag = true;
        }

        return flag;
    }

    private onSkip(): void {
        // this._mainTl.timeScale(5);
        this._mainTl.progress(1);
    }
}